import React from 'react';
import { styled } from 'linaria/react';
import { config } from '@app/config';
import theme from 'clad-ui/theme/chotot';
import Image from 'next/image';
import Tools from './Tool/Tool';
const Wrapper = /*#__PURE__*/styled("div")({
  name: "Wrapper",
  class: "w14dpw3e"
});
const ContentWrapper = /*#__PURE__*/styled("div")({
  name: "ContentWrapper",
  class: "c10riy5t"
});
const Avatar = /*#__PURE__*/styled("div")({
  name: "Avatar",
  class: "a6b9i9n"
});
const Content = /*#__PURE__*/styled("div")({
  name: "Content",
  class: "c1x6su60"
});
const Title = /*#__PURE__*/styled("h5")({
  name: "Title",
  class: "tv4v44m"
});
const Description = /*#__PURE__*/styled("p")({
  name: "Description",
  class: "dp6ub9d"
});
const Text = /*#__PURE__*/styled("div")({
  name: "Text",
  class: "tv11zoy"
});
const Promotion = /*#__PURE__*/styled("div")({
  name: "Promotion",
  class: "p1tw6yxk"
});
const PromotionInner = /*#__PURE__*/styled("div")({
  name: "PromotionInner",
  class: "p15o5cty"
});
const PromotionIcon = /*#__PURE__*/styled("span")({
  name: "PromotionIcon",
  class: "p2t6y5s"
});
const PromotionLink = /*#__PURE__*/styled("a")({
  name: "PromotionLink",
  class: "p1kl3zxi"
});
export const ChevronRight = props => <svg xmlns="http://www.w3.org/2000/svg" width="11" height="18" viewBox="0 0 11 18" {...props}>
    <g fill="none" fillRule="evenodd">
      <path stroke="#222222" strokeLinecap="round" strokeWidth="1.5" d="M1.125 3L6.75 8 1.125 13" transform="translate(1 1)" />
      <path stroke="#FFF" strokeWidth=".1" d="M0 0H9V16H0z" opacity=".01" transform="translate(1 1)" />
    </g>
  </svg>;
const RecruitmentHubEntrypoint = ({
  configData: {
    quick_shortcut: quickShortcut = []
  },
  isDone,
  onClick,
  data,
  isMobile,
  onClickShortcut
}) => {
  return <Wrapper>
      <ContentWrapper onClick={onClick}>
        <Avatar>
          <Image src="https://static.chotot.com/storage/ATS_STATIC_CDN/recruitment_hub_entrypoint_icon.svg" alt="recruitment_hub_entrypoint" layout="fill" objectFit="cover" />
        </Avatar>
        <Content>
          <Text>
            <Title>
              <span>Dành cho nhà tuyển dụng</span> <ChevronRight />
            </Title>
            <Description>
              Trải nghiệm các công cụ đắc lực: Ưu đãi NTD, Quản lý ứng viên, Tìm ứng viên mới, Gói
              Tuyển Dụng,...
            </Description>
          </Text>
        </Content>
      </ContentWrapper>
      {isDone && quickShortcut.length !== 0 ? <PromotionLink href={`${config.jobURL}/nha-tuyen-dung/uu-dai-nha-tuyen-dung-moi
      `} rel="dofollow">
          <Promotion style={{
        color: quickShortcut?.[0]?.text_color || '#222222'
      }}>
            <PromotionInner dangerouslySetInnerHTML={{
          __html: quickShortcut?.[0]?.text || '📣 Cập nhật: <strong>Gói Ưu Đãi 200K</strong> dành cho NTD mới'
        }} />
            <PromotionIcon>
              <ChevronRight />
            </PromotionIcon>
          </Promotion>
        </PromotionLink> : null}

      <Tools data={data} isMobile={isMobile} onClickShortcut={onClickShortcut} />
    </Wrapper>;
};
export default RecruitmentHubEntrypoint;

require("../../../.linaria-cache/src/components/RecruitmentHub/RecruitmentHubEntrypoint.linaria.module.css");